(() => {
  const initialize = (root) => {
    const shelves = root.matches?.('[data-am-shelf]') ? [root] : root.querySelectorAll('[data-am-shelf]');
    shelves.forEach((shelf) => {
      if (shelf.dataset.amReady) return;
      shelf.dataset.amReady = 'true';
      const tabs = Array.from(shelf.querySelectorAll('[data-am-tab]'));
      const panels = Array.from(shelf.querySelectorAll('[data-am-panel]'));
      const activate = (tab) => {
        tabs.forEach((item) => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel) => { panel.hidden = panel.dataset.amPanel !== tab.dataset.amTab; });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          activate(tabs[next]);
          tabs[next].focus();
        });
      });
    });
    root.querySelectorAll('[data-am-guide-link]').forEach((link) => {
      if (link.dataset.amReady) return;
      link.dataset.amReady = 'true';
      link.addEventListener('click', () => {
        const panel = document.getElementById(link.hash.slice(1));
        if (panel instanceof HTMLDetailsElement) panel.open = true;
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), {once: true});
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
